import React, { useContext, useState } from "react";
import { Grid } from "react-feather";
import { Link } from "react-router-dom";
import { Image, H5 } from "../../AbstractElements";
import CustomizerContext from "../../_helper/Customizer";
import ResidentLogo from "../../assets/favicon.png";
const SidebarLogo = () => {
  const { mixLayout, toggleSidebar, layout, layoutURL } =
    useContext(CustomizerContext);
  const [toggle, setToggle] = useState(false);

  const openCloseSidebar = () => {
    setToggle(!toggle);
    toggleSidebar(toggle);
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
    <div className="logo-wrapper">
      {layout1 !== "compact-wrapper dark-sidebar" &&
      layout1 !== "compact-wrapper color-sidebar" &&
      mixLayout ? (
        <Link to={`/dashboard`}>
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: `${ResidentLogo}`,
              alt: "",
            }}
          />
        </Link>
      ) : (
        <Link to={`dashboard/`}>
          <Image
            attrImage={{
              className: "img-fluid d-inline",
              src: `${require("../../assets/images/favicon.png")}`,
              alt: "",
            }}
          />
        </Link>
      )}
      <div className="back-btn" onClick={() => openCloseSidebar()}>
        <i className="fa fa-angle-left"></i>
      </div>
      <div className="toggle-sidebar" onClick={openCloseSidebar}>
        <Grid className="status_toggle middle sidebar-toggle" />
      </div>
    </div>
  );
};

export default SidebarLogo;
